<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M18.7 2.8C16.9 1 14.5 0 12 0S7.1 1 5.3 2.8 2.5 6.9 2.5 9.5c0 8 8.5 14.1 8.9 14.3.2.1.4.2.6.2s.4-.1.6-.2c.4-.3 8.9-6.3 8.9-14.3 0-2.6-1-4.9-2.8-6.7zm-6.7 9c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3z"
    />
  </svg>
</template>
